import { FormControlLabel, Radio } from "@mui/material"
import React from "react"

import { useFormControlLabelClasses, useRadioClasses } from "./styles"

interface IProps {
  checked?: boolean,
  className?: string,
  color?: string,
  disabled?: boolean,
  label: string,
  onChange?: (event: any) => void,
  value?: any,
  key?: string,
  onClick?: (event: any) => void,
}

export const LabeledRadio = (props: IProps) => {
  const clickHandler = props.onClick || function() {}

  return (
   <FormControlLabel
     className={props.className}
     classes={useFormControlLabelClasses()}
     label={props.label}
     control={
       <Radio
         checked={props.checked}
         className={props.className}
         color={"default"}
         disabled={props.disabled}
         onChange={props.onChange}
         value={props.value}
         classes={useRadioClasses({
           checked: props.checked,
           color: props.color || "primary"
         })}
         onClick={clickHandler}
       />
     }
   />
  )
}

